import { render, staticRenderFns } from "./ApproveGraduationList.vue?vue&type=template&id=05d8b236&scoped=true&"
import script from "./ApproveGraduationList.vue?vue&type=script&lang=js&"
export * from "./ApproveGraduationList.vue?vue&type=script&lang=js&"
import style0 from "./ApproveGraduationList.vue?vue&type=style&index=0&id=05d8b236&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d8b236",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
